// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var Report$ReactHooksTemplate = require("./report.res.js");
var Campaign$ReactHooksTemplate = require("../surveys/campaign.res.js");
var DataField$ReactHooksTemplate = require("../data_fields/dataField.res.js");
var UserDetail$ReactHooksTemplate = require("../common/UserDetail.res.js");
var CustomReport$ReactHooksTemplate = require("./CustomReport.res.js");
var SurveyDetail$ReactHooksTemplate = require("../surveys/surveyDetail.res.js");
var AggregateField$ReactHooksTemplate = require("./AggregateField.res.js");
var ReportTemplate$ReactHooksTemplate = require("./ReportTemplate.res.js");
var ResponseReport$ReactHooksTemplate = require("./ResponseReport.res.js");
var AggregateReport$ReactHooksTemplate = require("./AggregateReport.res.js");
var DataRestriction$ReactHooksTemplate = require("../settings/dataRestriction.res.js");
var CustomReportForm$ReactHooksTemplate = require("./CustomReportForm.res.js");
var DataFieldDropDown$ReactHooksTemplate = require("./DataFieldDropDown.res.js");
var SubscriptionPlans$ReactHooksTemplate = require("../SubscriptionPlans.res.js");
var ResponseReportForm$ReactHooksTemplate = require("./ResponseReportForm.res.js");
var AggregateReportForm$ReactHooksTemplate = require("./AggregateReportForm.res.js");
var OrganizationCustomReport$ReactHooksTemplate = require("./OrganizationCustomReport.res.js");

function ReportCrud(props) {
  var subscriptionPlans = props.subscriptionPlans;
  var toggleModal = props.toggleModal;
  var action = props.action;
  var report = props.report;
  var handleChange = props.handleChange;
  var match = React.useState(function (param) {
        return Report$ReactHooksTemplate.empty();
      });
  var setFormReport = match[1];
  var formReport = match[0];
  var match$1 = React.useState(function (param) {
        return /* [] */0;
      });
  var setTimeFrames = match$1[1];
  var match$2 = React.useState(function (param) {
        return /* [] */0;
      });
  var setDataFields = match$2[1];
  var dataFields = match$2[0];
  var match$3 = React.useState(function (param) {
        return /* [] */0;
      });
  var setSurveys = match$3[1];
  var surveys = match$3[0];
  var match$4 = React.useState(function (param) {
        return /* [] */0;
      });
  var setCampaigns = match$4[1];
  var campaigns = match$4[0];
  var match$5 = React.useState(function (param) {
        return /* [] */0;
      });
  var setOrganizationCustomReports = match$5[1];
  var isFormValid = function (formReport) {
    if (Report$ReactHooksTemplate.timeFrame(formReport) !== "") {
      return Report$ReactHooksTemplate.timeFrame(formReport) !== "Select Time Range";
    } else {
      return false;
    }
  };
  var fetchDataFields = function (param) {
    Js_promise.then_((function (dataFields) {
            return Promise.resolve(Curry._1(setDataFields, (function (param) {
                              return dataFields;
                            })));
          }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/data_fields?paginate=false", (function (param) {
                return Json_decode.field("data_fields", (function (param) {
                              return Json_decode.list(DataField$ReactHooksTemplate.decode, param);
                            }), param);
              })));
  };
  var fetchSurveysAndCampaigns = function (param) {
    Js_promise.then_((function (surveys) {
            return Promise.resolve(Curry._1(setSurveys, (function (param) {
                              return surveys;
                            })));
          }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/all_surveys", (function (param) {
                return Json_decode.field("surveys", (function (param) {
                              return Json_decode.list(SurveyDetail$ReactHooksTemplate.decode, param);
                            }), param);
              })));
  };
  var fetchCustomReports = function (param) {
    Js_promise.then_((function (reports) {
            return Promise.resolve(Curry._1(setOrganizationCustomReports, (function (param) {
                              return reports;
                            })));
          }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/organization_custom_reports", (function (param) {
                return Json_decode.field("organization_custom_reports", (function (param) {
                              return Json_decode.list(OrganizationCustomReport$ReactHooksTemplate.decode, param);
                            }), param);
              })));
  };
  var handleCustomReportChange = function (template, value) {
    var updateTemplate = CustomReport$ReactHooksTemplate.setReportLogicId(Belt_Option.getExn(Belt_Int.fromString(value)), template);
    Curry._1(setFormReport, (function (formReport) {
            return {
                    id: formReport.id,
                    name: formReport.name,
                    description: formReport.description,
                    reportTemplate: ReportTemplate$ReactHooksTemplate.setCustomReportTemplate(updateTemplate),
                    timeFrame: formReport.timeFrame,
                    creator: formReport.creator,
                    modifier: formReport.modifier,
                    filter: formReport.filter,
                    deletedFilter: formReport.deletedFilter
                  };
          }));
  };
  React.useEffect((function (param) {
          if (report !== undefined) {
            Curry._1(setFormReport, (function (param) {
                    return report;
                  }));
          } else {
            Curry._1(setFormReport, (function (param) {
                    return Report$ReactHooksTemplate.empty();
                  }));
          }
          Js_promise.then_((function (timeFrames) {
                  return Promise.resolve(Curry._1(setTimeFrames, (function (param) {
                                    return timeFrames;
                                  })));
                }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/reports/time_frames", (function (param) {
                      return Json_decode.field("time_frames", (function (param) {
                                    return Json_decode.list(Json_decode.string, param);
                                  }), param);
                    })));
          fetchDataFields();
          fetchSurveysAndCampaigns();
          fetchCustomReports();
        }), []);
  var handleReportChange = function (field, $$event) {
    var value = Utils$ReactHooksTemplate.formTargetValue($$event);
    switch (field) {
      case "Name" :
          return Curry._1(setFormReport, (function (formReport) {
                        return {
                                id: formReport.id,
                                name: value,
                                description: formReport.description,
                                reportTemplate: formReport.reportTemplate,
                                timeFrame: formReport.timeFrame,
                                creator: formReport.creator,
                                modifier: formReport.modifier,
                                filter: formReport.filter,
                                deletedFilter: formReport.deletedFilter
                              };
                      }));
      case "Description" :
          return Curry._1(setFormReport, (function (formReport) {
                        return {
                                id: formReport.id,
                                name: formReport.name,
                                description: value,
                                reportTemplate: formReport.reportTemplate,
                                timeFrame: formReport.timeFrame,
                                creator: formReport.creator,
                                modifier: formReport.modifier,
                                filter: formReport.filter,
                                deletedFilter: formReport.deletedFilter
                              };
                      }));
      case "ReportTemplate" :
          var template = ReportTemplate$ReactHooksTemplate.setTemplateFromName(value);
          return Curry._1(setFormReport, (function (formReport) {
                        return {
                                id: formReport.id,
                                name: formReport.name,
                                description: formReport.description,
                                reportTemplate: template,
                                timeFrame: formReport.timeFrame,
                                creator: formReport.creator,
                                modifier: formReport.modifier,
                                filter: formReport.filter,
                                deletedFilter: formReport.deletedFilter
                              };
                      }));
      case "TimeFrame" :
          return Curry._1(setFormReport, (function (formReport) {
                        return {
                                id: formReport.id,
                                name: formReport.name,
                                description: formReport.description,
                                reportTemplate: formReport.reportTemplate,
                                timeFrame: value,
                                creator: formReport.creator,
                                modifier: formReport.modifier,
                                filter: formReport.filter,
                                deletedFilter: formReport.deletedFilter
                              };
                      }));
      
    }
  };
  var handleAggregateReportChange = function (template, field, $$event) {
    var value = Utils$ReactHooksTemplate.formTargetValue($$event);
    var updateTemplate;
    switch (field) {
      case "dataField" :
          var dataField = Belt_List.getBy(dataFields, (function (dataField) {
                  return DataField$ReactHooksTemplate.name(dataField) === value;
                }));
          var aggregateField = AggregateReport$ReactHooksTemplate.aggregateFields(template);
          var aggregateField$1 = aggregateField !== undefined ? AggregateField$ReactHooksTemplate.setDataField(dataField, aggregateField) : AggregateField$ReactHooksTemplate.setDataField(dataField, AggregateField$ReactHooksTemplate.empty);
          var match = DataField$ReactHooksTemplate.dataType(Belt_Option.getExn(dataField));
          var timestampUpdatedAggregateField;
          timestampUpdatedAggregateField = match.TAG === "DateType" ? AggregateField$ReactHooksTemplate.setIsTimestamp(true, aggregateField$1) : AggregateField$ReactHooksTemplate.setIsTimestamp(false, aggregateField$1);
          updateTemplate = AggregateReport$ReactHooksTemplate.setAggregateFields(timestampUpdatedAggregateField, template);
          break;
      case "metric" :
          updateTemplate = AggregateReport$ReactHooksTemplate.setMetric(AggregateReport$ReactHooksTemplate.metricFromString(value), template);
          break;
      case "timeFrame" :
          var aggregateField$2 = AggregateReport$ReactHooksTemplate.aggregateFields(template);
          var aggregateField$3 = aggregateField$2 !== undefined ? AggregateField$ReactHooksTemplate.setTimeFrame(value, aggregateField$2) : AggregateField$ReactHooksTemplate.setTimeFrame(value, AggregateField$ReactHooksTemplate.empty);
          updateTemplate = AggregateReport$ReactHooksTemplate.setAggregateFields(aggregateField$3, template);
          break;
      default:
        updateTemplate = template;
    }
    Curry._1(setFormReport, (function (formReport) {
            return {
                    id: formReport.id,
                    name: formReport.name,
                    description: formReport.description,
                    reportTemplate: ReportTemplate$ReactHooksTemplate.setAggregateReportTemplate(updateTemplate),
                    timeFrame: formReport.timeFrame,
                    creator: formReport.creator,
                    modifier: formReport.modifier,
                    filter: formReport.filter,
                    deletedFilter: formReport.deletedFilter
                  };
          }));
  };
  var handleResponseReportSurveyChange = function (template, $$event) {
    var value = Utils$ReactHooksTemplate.formTargetValue($$event);
    var survey = Belt_List.getBy(surveys, (function (survey) {
            return SurveyDetail$ReactHooksTemplate.name(survey) === value;
          }));
    var updateTemplate = ResponseReport$ReactHooksTemplate.setSurvey(survey, template);
    Js_promise.then_((function (campaigns) {
            return Promise.resolve(Curry._1(setCampaigns, (function (param) {
                              return campaigns;
                            })));
          }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/survey_campaigns?survey_id=" + String(SurveyDetail$ReactHooksTemplate.id(Belt_Option.getExn(survey))), (function (param) {
                return Json_decode.field("campaigns", (function (param) {
                              return Json_decode.list(Campaign$ReactHooksTemplate.decode, param);
                            }), param);
              })));
    Curry._1(setFormReport, (function (formReport) {
            return {
                    id: formReport.id,
                    name: formReport.name,
                    description: formReport.description,
                    reportTemplate: ReportTemplate$ReactHooksTemplate.setResponseReportTemplate(updateTemplate),
                    timeFrame: formReport.timeFrame,
                    creator: formReport.creator,
                    modifier: formReport.modifier,
                    filter: formReport.filter,
                    deletedFilter: formReport.deletedFilter
                  };
          }));
  };
  var handleResponseReportCampaignChange = function (template, options) {
    var campaigns$1 = Belt_List.map(options, (function (campaign) {
            return Belt_Option.getExn(Belt_List.getBy(campaigns, (function (campaign$1) {
                              return Campaign$ReactHooksTemplate.name(campaign$1) === campaign;
                            })));
          }));
    var updateTemplate = ResponseReport$ReactHooksTemplate.setCampaigns(campaigns$1, template);
    Curry._1(setFormReport, (function (formReport) {
            return {
                    id: formReport.id,
                    name: formReport.name,
                    description: formReport.description,
                    reportTemplate: ReportTemplate$ReactHooksTemplate.setResponseReportTemplate(updateTemplate),
                    timeFrame: formReport.timeFrame,
                    creator: formReport.creator,
                    modifier: formReport.modifier,
                    filter: formReport.filter,
                    deletedFilter: formReport.deletedFilter
                  };
          }));
  };
  var createNewFilter = function (param) {
    var newFilterList = List.length(Report$ReactHooksTemplate.filter(formReport)) < 1 ? ({
          hd: DataRestriction$ReactHooksTemplate.empty(),
          tl: /* [] */0
        }) : List.append(Report$ReactHooksTemplate.filter(formReport), {
            hd: DataRestriction$ReactHooksTemplate.empty(),
            tl: /* [] */0
          });
    Curry._1(setFormReport, (function (formReport) {
            return {
                    id: formReport.id,
                    name: formReport.name,
                    description: formReport.description,
                    reportTemplate: formReport.reportTemplate,
                    timeFrame: formReport.timeFrame,
                    creator: formReport.creator,
                    modifier: formReport.modifier,
                    filter: newFilterList,
                    deletedFilter: formReport.deletedFilter
                  };
          }));
  };
  var tmp;
  switch (action) {
    case "Create" :
        tmp = JsxRuntime.jsx("div", {
              children: "New Report"
            });
        break;
    case "Edit" :
        tmp = JsxRuntime.jsx("div", {
              children: "Edit Report"
            });
        break;
    case "Delete" :
        tmp = JsxRuntime.jsx("div", {
              children: "Delete Report"
            });
        break;
    
  }
  var tmp$1;
  var exit = 0;
  switch (action) {
    case "Create" :
    case "Edit" :
        exit = 1;
        break;
    case "Delete" :
        var template = Report$ReactHooksTemplate.reportTemplate(formReport);
        var tmp$2;
        if (template !== undefined) {
          var match$6 = ReportTemplate$ReactHooksTemplate.template(template);
          switch (match$6.TAG) {
            case "AggregateReport" :
                tmp$2 = AggregateReport$ReactHooksTemplate.templateType;
                break;
            case "CustomReport" :
                tmp$2 = CustomReport$ReactHooksTemplate.templateType;
                break;
            case "ResponseReport" :
                tmp$2 = ResponseReport$ReactHooksTemplate.templateType;
                break;
            
          }
        } else {
          tmp$2 = "Select Template";
        }
        var user = Report$ReactHooksTemplate.creator(formReport);
        tmp$1 = JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: "Name",
                                    className: "text-sm font-medium w-1/5"
                                  }),
                              JsxRuntime.jsx("input", {
                                    className: "outline-none border border-gray-400 h-10 w-3/5 rounded px-3 py-2 text-sm",
                                    disabled: true,
                                    type: "text",
                                    value: Report$ReactHooksTemplate.name(formReport)
                                  })
                            ],
                            className: "flex gap-1 items-center w-full"
                          }),
                      className: "flex mt-30-px mb-30-px"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: "Description",
                                    className: "text-sm font-medium w-1/5"
                                  }),
                              JsxRuntime.jsx("input", {
                                    className: "outline-none border border-gray-400 h-10 w-3/5 rounded px-3 py-2 text-sm",
                                    disabled: true,
                                    type: "text",
                                    value: Report$ReactHooksTemplate.description(formReport)
                                  })
                            ],
                            className: "flex gap-1 items-center w-full"
                          }),
                      className: "flex mb-30-px"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: "Report Template",
                                    className: "text-sm font-medium w-1/5"
                                  }),
                              JsxRuntime.jsx("input", {
                                    className: "outline-none border border-gray-400 h-10 w-3/5 rounded px-3 py-2 text-sm",
                                    disabled: true,
                                    type: "text",
                                    value: tmp$2
                                  })
                            ],
                            className: "flex gap-1 items-center w-full"
                          }),
                      className: "flex mb-30-px"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: "Time Frame",
                                    className: "text-sm font-medium w-1/5"
                                  }),
                              JsxRuntime.jsx("input", {
                                    className: "outline-none border border-gray-400 h-10 w-3/5 rounded px-3 py-2 text-sm capitalize",
                                    disabled: true,
                                    type: "text",
                                    value: Utils$ReactHooksTemplate.humanize(Report$ReactHooksTemplate.timeFrame(formReport))
                                  })
                            ],
                            className: "flex gap-1 items-center w-full"
                          }),
                      className: "flex mb-30-px"
                    }),
                $$Array.of_list(List.map((function (x) {
                            return JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsx("div", {
                                                              children: "Data Field",
                                                              className: "text-sm font-medium w-1/5"
                                                            }),
                                                        JsxRuntime.jsx("input", {
                                                              className: " flex outline-none border border-gray-400 h-10 w-3/5 rounded px-3 py-2 text-sm capitalize",
                                                              disabled: true,
                                                              type: "text",
                                                              value: DataField$ReactHooksTemplate.name(DataRestriction$ReactHooksTemplate.dataField(x))
                                                            })
                                                      ],
                                                      className: "flex gap-1 items-center w-full mb-30-px"
                                                    }),
                                                JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsx("div", {
                                                              children: "Options",
                                                              className: "text-sm font-medium w-1/5"
                                                            }),
                                                        JsxRuntime.jsx("div", {
                                                              children: $$Array.of_list(List.map((function (x) {
                                                                          return JsxRuntime.jsx("p", {
                                                                                      children: x,
                                                                                      className: "bg-ghostwhite text-center px-3 rounded-2xl border border-gray-400 mr-2 mb-2",
                                                                                      disabled: true
                                                                                    });
                                                                        }), DataRestriction$ReactHooksTemplate.value(x))),
                                                              className: "flex flex-wrap outline-none border border-gray-400 w-3/5 rounded px-3 py-2 text-sm capitalize"
                                                            })
                                                      ],
                                                      className: "flex gap-1 items-center w-full"
                                                    })
                                              ],
                                              className: "flex flex-col gap-2 w-full"
                                            }),
                                        className: "flex mb-30-px"
                                      });
                          }), Report$ReactHooksTemplate.filter(formReport))),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: "Created By",
                                    className: "text-sm font-medium w-1/5"
                                  }),
                              JsxRuntime.jsx("input", {
                                    className: "outline-none border border-gray-400 h-10 w-3/5 rounded px-3 py-2 text-sm",
                                    disabled: true,
                                    type: "text",
                                    value: user !== undefined ? UserDetail$ReactHooksTemplate.email(user) : ""
                                  })
                            ],
                            className: "flex gap-1 items-center w-full"
                          }),
                      className: "flex mb-30-px"
                    })
              ]
            });
        break;
    
  }
  if (exit === 1) {
    var tmp$3;
    var exit$1 = 0;
    switch (action) {
      case "Edit" :
          var template$1 = Report$ReactHooksTemplate.reportTemplate(formReport);
          var tmp$4;
          if (template$1 !== undefined) {
            var match$7 = ReportTemplate$ReactHooksTemplate.template(template$1);
            switch (match$7.TAG) {
              case "AggregateReport" :
                  tmp$4 = AggregateReport$ReactHooksTemplate.templateType;
                  break;
              case "CustomReport" :
                  tmp$4 = CustomReport$ReactHooksTemplate.templateType;
                  break;
              case "ResponseReport" :
                  tmp$4 = ResponseReport$ReactHooksTemplate.templateType;
                  break;
              
            }
          } else {
            tmp$4 = "Select Template";
          }
          tmp$3 = JsxRuntime.jsx("input", {
                className: "outline-none border border-gray-400 h-10 w-3/5 rounded px-3 py-2 text-sm",
                disabled: true,
                type: "text",
                value: tmp$4
              });
          break;
      case "Create" :
      case "Delete" :
          exit$1 = 2;
          break;
      
    }
    if (exit$1 === 2) {
      var template$2 = Report$ReactHooksTemplate.reportTemplate(formReport);
      var tmp$5;
      if (template$2 !== undefined) {
        var match$8 = ReportTemplate$ReactHooksTemplate.template(template$2);
        switch (match$8.TAG) {
          case "AggregateReport" :
              tmp$5 = AggregateReport$ReactHooksTemplate.templateType;
              break;
          case "CustomReport" :
              tmp$5 = CustomReport$ReactHooksTemplate.templateType;
              break;
          case "ResponseReport" :
              tmp$5 = ResponseReport$ReactHooksTemplate.templateType;
              break;
          
        }
      } else {
        tmp$5 = "Select Template";
      }
      tmp$3 = JsxRuntime.jsxs("select", {
            children: [
              JsxRuntime.jsx("option", {
                    children: "Select Template",
                    disabled: true,
                    value: "Select Template"
                  }, "0"),
              $$Array.of_list(Belt_List.map(ReportTemplate$ReactHooksTemplate.templateList, (function (templateName) {
                          return JsxRuntime.jsx("option", {
                                      children: templateName,
                                      disabled: templateName === CustomReport$ReactHooksTemplate.templateType && !SubscriptionPlans$ReactHooksTemplate.isEnabled(subscriptionPlans, "CustomReports"),
                                      value: templateName
                                    }, templateName);
                        })))
            ],
            className: "block border px-3 py-2 border-gray-400 cursor-pointer\n                                    w-3/5 bg-white rounded capitalize mr-6 text-sm",
            placeholder: "Select Template",
            value: tmp$5,
            onChange: (function (param) {
                return handleReportChange("ReportTemplate", param);
              })
          });
    }
    var reportTemplate = Report$ReactHooksTemplate.reportTemplate(formReport);
    var tmp$6;
    if (reportTemplate !== undefined) {
      var template$3 = ReportTemplate$ReactHooksTemplate.template(reportTemplate);
      switch (template$3.TAG) {
        case "AggregateReport" :
            tmp$6 = JsxRuntime.jsx(AggregateReportForm$ReactHooksTemplate.make, {
                  template: template$3._0,
                  handleAggregateReportChange: handleAggregateReportChange,
                  dataFields: dataFields
                });
            break;
        case "CustomReport" :
            tmp$6 = JsxRuntime.jsx(CustomReportForm$ReactHooksTemplate.make, {
                  template: template$3._0,
                  organizationCustomReports: match$5[0],
                  handleCustomReportChange: handleCustomReportChange
                });
            break;
        case "ResponseReport" :
            tmp$6 = JsxRuntime.jsx(ResponseReportForm$ReactHooksTemplate.make, {
                  template: template$3._0,
                  surveys: surveys,
                  campaigns: campaigns,
                  handleResponseReportSurveyChange: handleResponseReportSurveyChange,
                  handleResponseReportCampaignChange: handleResponseReportCampaignChange
                });
            break;
        
      }
    } else {
      tmp$6 = JsxRuntime.jsx(JsxRuntime.Fragment, {});
    }
    tmp$1 = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                                children: "Name",
                                className: "text-sm font-medium w-1/5"
                              }),
                          JsxRuntime.jsx("input", {
                                className: "outline-none border border-gray-400 h-10 w-3/5 rounded px-3 py-2 text-sm",
                                type: "text",
                                value: Report$ReactHooksTemplate.name(formReport),
                                onChange: (function (param) {
                                    return handleReportChange("Name", param);
                                  })
                              })
                        ],
                        className: "flex gap-1 items-center w-full"
                      }),
                  className: "flex mb-30-px items-center"
                }),
            JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                                children: "Description",
                                className: "text-sm font-medium w-1/5"
                              }),
                          JsxRuntime.jsx("input", {
                                className: "outline-none border border-gray-400 h-10 w-3/5 rounded px-3 py-2 text-sm",
                                type: "text",
                                value: Report$ReactHooksTemplate.description(formReport),
                                onChange: (function (param) {
                                    return handleReportChange("Description", param);
                                  })
                              })
                        ],
                        className: "flex gap-1 items-center w-full"
                      }),
                  className: "flex mb-30-px items-center"
                }),
            JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                                children: "Time Range",
                                className: "text-sm font-medium w-1/5"
                              }),
                          JsxRuntime.jsxs("select", {
                                children: [
                                  JsxRuntime.jsx("option", {
                                        children: "Select Time Range",
                                        disabled: true,
                                        value: "Select Time Range"
                                      }, "0"),
                                  $$Array.of_list(Belt_List.map(match$1[0], (function (timeFrame) {
                                              return JsxRuntime.jsx("option", {
                                                          children: Utils$ReactHooksTemplate.humanize(timeFrame),
                                                          value: timeFrame
                                                        }, timeFrame);
                                            })))
                                ],
                                className: "block border px-3 py-2 border-gray-400\n                             w-3/5 bg-white rounded capitalize mr-6 text-sm cursor-pointer",
                                placeholder: "Select Time Range",
                                value: Report$ReactHooksTemplate.timeFrame(formReport) === "" ? "Select Time Range" : Report$ReactHooksTemplate.timeFrame(formReport),
                                onChange: (function (param) {
                                    return handleReportChange("TimeFrame", param);
                                  })
                              })
                        ],
                        className: "flex gap-1 items-center w-full"
                      }),
                  className: "flex mb-30-px items-center"
                }),
            JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                                children: "Report Template",
                                className: "text-sm font-medium w-1/5"
                              }),
                          tmp$3
                        ],
                        className: "flex gap-1 items-center w-full"
                      }),
                  className: "flex mb-30-px items-center"
                }),
            List.length(Report$ReactHooksTemplate.filter(formReport)) < 1 ? JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("img", {
                                  className: "flex h-4 w-4 mr-2",
                                  src: Image$ReactHooksTemplate.plusCircle
                                }),
                            JsxRuntime.jsx("div", {
                                  children: "Add new filter",
                                  className: "flex"
                                })
                          ],
                          className: "mb-30-px flex w-1/4 items-center bg-ghostwhite border border-gray-400 shadow-inner rounded py-2 px-3 text-xs font-normal cursor-pointer",
                          onClick: (function (param) {
                              createNewFilter();
                            })
                        }),
                    className: "flex justify-start w-4/5"
                  }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
            $$Array.of_list(List.mapi((function (i, x) {
                        return JsxRuntime.jsx(DataFieldDropDown$ReactHooksTemplate.make, {
                                    dataRestriction: x,
                                    dataFields: dataFields,
                                    updateReport: (function (param) {
                                        return Curry._1(setFormReport, (function (formReport) {
                                                      var updatedFilters = List.mapi((function (i$1, filter) {
                                                              if (i$1 === i) {
                                                                return DataRestriction$ReactHooksTemplate.isvalidDatarestriction(param);
                                                              } else {
                                                                return filter;
                                                              }
                                                            }), Report$ReactHooksTemplate.filter(formReport));
                                                      return {
                                                              id: formReport.id,
                                                              name: formReport.name,
                                                              description: formReport.description,
                                                              reportTemplate: formReport.reportTemplate,
                                                              timeFrame: formReport.timeFrame,
                                                              creator: formReport.creator,
                                                              modifier: formReport.modifier,
                                                              filter: updatedFilters,
                                                              deletedFilter: formReport.deletedFilter
                                                            };
                                                    }));
                                      }),
                                    createNewFilter: createNewFilter,
                                    deleteFilter: (function (param) {
                                        var match;
                                        switch (action) {
                                          case "Create" :
                                              match = [
                                                Belt_List.keepWithIndex(Report$ReactHooksTemplate.filter(formReport), (function (param, i$1) {
                                                        return i$1 !== i;
                                                      })),
                                                /* [] */0
                                              ];
                                              break;
                                          case "Edit" :
                                              match = [
                                                Belt_List.keepWithIndex(Report$ReactHooksTemplate.filter(formReport), (function (param, i$1) {
                                                        return i$1 !== i;
                                                      })),
                                                Belt_List.map(Belt_List.keepWithIndex(Report$ReactHooksTemplate.filter(formReport), (function (x$1, i$1) {
                                                            if (i$1 === i) {
                                                              return Caml_obj.equal(x$1, x);
                                                            } else {
                                                              return false;
                                                            }
                                                          })), (function (d) {
                                                        return DataRestriction$ReactHooksTemplate.setDestroy(d, true);
                                                      }))
                                              ];
                                              break;
                                          case "Delete" :
                                              match = [
                                                /* [] */0,
                                                /* [] */0
                                              ];
                                              break;
                                          
                                        }
                                        var deletedFilter = match[1];
                                        var updatedFilter = match[0];
                                        Curry._1(setFormReport, (function (formReport) {
                                                return {
                                                        id: formReport.id,
                                                        name: formReport.name,
                                                        description: formReport.description,
                                                        reportTemplate: formReport.reportTemplate,
                                                        timeFrame: formReport.timeFrame,
                                                        creator: formReport.creator,
                                                        modifier: formReport.modifier,
                                                        filter: updatedFilter,
                                                        deletedFilter: List.append(deletedFilter, formReport.deletedFilter)
                                                      };
                                              }));
                                      })
                                  });
                      }), Report$ReactHooksTemplate.filter(formReport))),
            tmp$6
          ]
        });
  }
  var tmp$7;
  switch (action) {
    case "Create" :
    case "Edit" :
        tmp$7 = "bg-palatinateblue";
        break;
    case "Delete" :
        tmp$7 = "bg-deepcarminepink";
        break;
    
  }
  var tmp$8;
  switch (action) {
    case "Create" :
    case "Edit" :
        tmp$8 = isFormValid(formReport) ? "" : " opacity-50 cursor-not-allowed";
        break;
    case "Delete" :
        tmp$8 = "";
        break;
    
  }
  var tmp$9;
  switch (action) {
    case "Create" :
    case "Edit" :
        tmp$9 = !isFormValid(formReport);
        break;
    case "Delete" :
        tmp$9 = false;
        break;
    
  }
  var tmp$10;
  switch (action) {
    case "Create" :
    case "Edit" :
        tmp$10 = "Save";
        break;
    case "Delete" :
        tmp$10 = "Delete";
        break;
    
  }
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              tmp,
                              JsxRuntime.jsx("img", {
                                    className: "h-14-px float-right cursor-pointer",
                                    src: Image$ReactHooksTemplate.closeIcon,
                                    onClick: toggleModal
                                  })
                            ],
                            className: "p-8 text-lg font-bold flex justify-between border-b border-gray-200"
                          }),
                      JsxRuntime.jsx("div", {
                            children: tmp$1,
                            className: "h-full text-base p-8 overflow-auto"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("button", {
                                    children: "Discard",
                                    className: "bg-ghostwhite border border-gray-400\n          flex rounded py-3 px-6 text-xs",
                                    id: "close_modal",
                                    onClick: toggleModal
                                  }),
                              JsxRuntime.jsx("input", {
                                    className: "border border-gray-400\n            flex rounded py-3 px-6 text-xs text-white " + tmp$7 + tmp$8,
                                    disabled: tmp$9,
                                    type: "submit",
                                    value: tmp$10,
                                    onClick: (function (param) {
                                        switch (action) {
                                          case "Create" :
                                          case "Edit" :
                                              break;
                                          case "Delete" :
                                              return Curry._2(handleChange, formReport, action);
                                          
                                        }
                                        if (isFormValid(formReport)) {
                                          return Curry._2(handleChange, formReport, action);
                                        }
                                        
                                      })
                                  })
                            ],
                            className: "p-8 flex gap-3 justify-end border-t border-gray-200"
                          })
                    ],
                    className: "flex flex-col justify-between h-full"
                  }),
              className: "bg-white modal-campaign z-10 shadow relative border border-gray-300 pointer-events-auto"
            });
}

var make = ReportCrud;

exports.make = make;
/* react Not a pure module */
